import store from "@/stores";

var GlobalHelpersMixin = {
  data() {
    return {
      loading: true,
      entityLoading: false,
      entityResults: {},
      entities: {},
      entityLastPage: {}
    };
  },
  filters: {
    shorten: function(textInput, length) {
      return textInput ? textInput.slice(0, length) + "..." : "";
    },
  },
  methods: {
    scroll(element, behavior = "smooth") {
      if (this.$refs[element]) {
        let scrollHeight = this.$refs[element].scrollHeight;
        if (behavior === "direct") {
          this.$refs[element].scrollTop = scrollHeight;
          return;
        }
        this.$refs[element].scroll({
          top: scrollHeight,
          left: 0,
          behavior: behavior,
        });
      }
    },
    capitalize(s) {
      return typeof s !== "string"
        ? ""
        : s.charAt(0).toUpperCase() + s.slice(1);
    },
    popup(Params) {
      let params = Params;
      if (typeof Params === "string") {
        params = {
          type: "info",
          text: Params,
        };
      }

      let popup = {
        ...params,
        id: this.$uuid.v4(),
        type: params.type || "info",
        autohide: params.autohide || true,
      };
      this.$store.dispatch("popup/addPopup", popup);
    },
    async getEntity(Name, Custom = false){
      let page = null;
      let entityName = Name + (Custom || "");

      if (this.entityLastPage[entityName]){
        return this.entities[entityName];
      } else if (this.entityResults[entityName]){
        page = this.entityResults[entityName].current_page + 1;
      }

      this.entityLoading = true;

      let resolveEntities = (Result)=>{
        this.entityLoading = false;
        this.entityResults[entityName] = Result;

        if (this.entityResults[entityName].last_page === this.entityResults[entityName].current_page){
          this.$set(this.entityLastPage, entityName, true);
        }

        if (this.entities[entityName]){
          Result.data.forEach((e) => {
            if (this.entities[entityName].find((u) => u.id === e.id)) {
              return;
            }
            this.entities[entityName].push(e);
          });
        } else {
          this.entities[entityName] = Result.data;
        }
      }

      if (Custom){
        await this.$store.getters[`${Name}/api`].Custom[Custom](typeof page === "number" ? { page: page } : null).then(resolveEntities);
      } else {
        await this.$store.getters[`${Name}/api`]
          .Get(typeof page === "number" ? { page: page } : null)
          .then(resolveEntities);
      }
        return this.entities[entityName];
    },
    generateUuid() {
      return this.$uuid.v4();
    },
    goTo(Route) {
      // Avoid navigation duplicated (router-to is router-from)
      if (this.$route.fullPath === Route) return;

      this.$router.push(Route).catch((err) => {
        console.error("Es gab einen Fehler: " + err);
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    loaded() {
      this.loading = false;
    },
    roleCheck(Roles) {
      let ownUser = store.getters["auth/user"];
      if (!ownUser) return;
      if (Array.isArray(Roles)) {
        return Roles.some((e) => ownUser.roles.includes(e));
      } else if (typeof Roles === "string") {
        return ownUser.roles.includes(Roles);
      }
    },
    permissionCheck(Permission) {
      let ownUser = store.getters["auth/user"];
      return (
        ownUser.permissions.includes(Permission) ||
        ownUser.permissions.includes("*")
      );
    },
  },
};

export default GlobalHelpersMixin;
